import { render, staticRenderFns } from "./SelfServiceDiagnosticLog.vue?vue&type=template&id=6c3b45b4&scoped=true"
import script from "./SelfServiceDiagnosticLog.vue?vue&type=script&lang=js"
export * from "./SelfServiceDiagnosticLog.vue?vue&type=script&lang=js"
import style0 from "./SelfServiceDiagnosticLog.vue?vue&type=style&index=0&id=6c3b45b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3b45b4",
  null
  
)

export default component.exports